<template>
    <PrimeAvatar
        size="md"
        v-if="!isRefreshing"
    >
        {{ initials }}
    </PrimeAvatar>
    <div
        v-else
        class="loading-image"
    >
        <svg
            class="loading-spinner"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                class="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                stroke-width="4"
            ></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    name: {
        type: String,
        required: false,
        default: 'Anonymous',
    },
    person_id: {
        type: Number,
        required: true,
    },
});

const initials = computed(() => {
    return props.name
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase())
        .join('')
        .slice(0, 2);
});

const { isRefreshing } = useAvatarRefresh();
</script>

<style lang="scss" scoped>
// loading image skeleton
.loading-image {
    @apply bg-gray-100 rounded-full flex items-center justify-center;
    width: 100%;
    height: 100%;
    
    .loading-spinner {
        @apply text-gray-400;
        width: 40%;
        height: 40%;
        animation: spin 1s linear infinite;
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
